import ENV from "config/Env";
import { localQueryKey, permanentBackendQueryKey } from "hooks";

import type { DMSIDS, DMS_CAPABILITY_SUPPORTED_STATUSES } from "models";

const component = "DMSCapabilitiesDashboard";

type DMSCapabilityItem = {
  object: string;
  action: string;
  field: string;
  field_description: string;
  supported: DMS_CAPABILITY_SUPPORTED_STATUSES;
};

export type DMSCapability = {
  id: DMSIDS;
  capabilities: DMSCapabilityItem[];
};

export const DMSCapabilitiesQueryKeys = {
  capabilities: permanentBackendQueryKey<DMSCapability[]>({ component, baseUrl: ENV.dmsAccessorBaseURL, endpoint: "/capabilities/dms/list" }),
  selectedDMSIds: localQueryKey<number[] | null>({ component, data: "selectedDMSIds" })
};
